export default {
    "name": "CollectionMembershipLocalInventory",
    "kind": "HoudiniFragment",
    "hash": "025371e20bfd6893c5d271ccf3c22e940e7bcf8b200bc103c5b3a4c1ee246004",

    "raw": `fragment CollectionMembershipLocalInventory on Inventory {
  innodbInventoryid: id
  storeId
  skuNumber
  tagNumber
  inventoryType {
    id
    name
  }
  quantity
  quantityAvailable
  manufacturer {
    id
    name
  }
  model {
    id
    name
  }
  category {
    id
    name
  }
  id
  __typename
}
`,

    "rootType": "Inventory",
    "stripVariables": [],

    "selection": {
        "fields": {
            "innodbInventoryid": {
                "type": "UInt",
                "keyRaw": "innodbInventoryid",
                "visible": true
            },

            "storeId": {
                "type": "UInt",
                "keyRaw": "storeId",
                "visible": true
            },

            "skuNumber": {
                "type": "UInt",
                "keyRaw": "skuNumber",
                "visible": true
            },

            "tagNumber": {
                "type": "String",
                "keyRaw": "tagNumber",
                "visible": true
            },

            "inventoryType": {
                "type": "InventoryType",
                "keyRaw": "inventoryType",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "quantity": {
                "type": "Decimal6",
                "keyRaw": "quantity",
                "visible": true
            },

            "quantityAvailable": {
                "type": "Decimal6",
                "keyRaw": "quantityAvailable",
                "visible": true
            },

            "manufacturer": {
                "type": "Manufacturer",
                "keyRaw": "manufacturer",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "model": {
                "type": "Model",
                "keyRaw": "model",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "category": {
                "type": "Category",
                "keyRaw": "category",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "id": {
                "type": "UInt",
                "keyRaw": "id",
                "visible": true
            },

            "__typename": {
                "type": "String",
                "keyRaw": "__typename",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    }
};

"HoudiniHash=a9e1c0be13c8086a51d0e24fe75771a2b0226b596186a07ca7cb06d986d65e0d";